import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { academylist } from "../../../services/admin";
import { deletevisitor, listvisitor } from "../../../services/common";
import Swal from "sweetalert2";
import Select from "react-select";

export default function Allvisitors() {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");

  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() =>
                navigate(`/frontdesk/visitordetail/${params.value}`)
              }
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a
              onClick={() => deleteenq(params.value)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Date",
      field: "visitor_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
     
    },
    {
      headerName: "Name",
      field: "visitor_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Meeting With",
      field: "meeting_with",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "In Time",
      field: "visitor_intime",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Out Time",
      field: "visitor_outtime",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnDDefs = [
    {
      headerName: "Date",
      field: "visitor_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    
    },
    {
      headerName: "Name",
      field: "visitor_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Meeting With",
      field: "meeting_with",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "In Time",
      field: "visitor_intime",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Out Time",
      field: "visitor_outtime",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Deleted Date",
      field: "updated_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
  ];
  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {

    const path = location.pathname.split("/")[2];
    setUrllink(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);
              }
            }
           
          }
        }
      });
    }else{
      setAcaID("");
    }
    if (localStorage.getItem("ADate") !== '') {
      setFDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      setTDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      listall(
        "",
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
        path
      );
    } else {
      setFDate(moment(new Date()).format("YYYY-MM-DD"));
      setTDate(moment(new Date()).format("YYYY-MM-DD"));
      listall(
        "",
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
        path
      );
    }

  }, [location.pathname]);

  function listall(aid, fdte, tdte, ltype) {
    setFDate(fdte);
    setTDate(tdte);
    setFilterProduct([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("from_date", fdte);
    temp.append("to_date", tdte);
    if (ltype === "deletevisitor") {
      temp.append("status", 0);
    } else {
      temp.append("status", 1);
    }
    listvisitor(temp).then((res) => {
      if (res.status === true) {
        // setFilterProduct(res.data);
         if(res.data.length>0){
                  const cdata=res.data.map((item) => {
                    return{
                      ...item,
                      visitor_date: moment(item.visitor_date).format("DD-MM-YYYY"),
                    }
                  });
                  setFilterProduct(cdata);
                }
      }
    });
  }

  function deleteenq(did) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deletevisitor(did).then((response) => {
          if (response.status === true) {
            navigate("/frontdesk/deletevisitor");
          }
        });
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e, fdate, tdate, urllink);
    } else {
      setAcaID("");
      listall("", fdate, tdate, urllink);
    }
  }
  return (
    <div>
      <div className="page-header">
        {urllink === "deletevisitor" && (
          <h2 className="main-content-title tx-24 mg-b-5">Delete Visitors</h2>
        )}
        {urllink === "allvisitors" && (
          <h2 className="main-content-title tx-24 mg-b-5">All Visitors</h2>
        )}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Front Desk</a>
          </li>
          {urllink === "deletevisitor" && (
            <li className="breadcrumb-item active" aria-current="page">
              Delete Visitors
            </li>
          )}
          {urllink === "allvisitors" && (
            <li className="breadcrumb-item active" aria-current="page">
              All Visitors
            </li>
          )}
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="card custom-card mg-b-20">
            <div className="card-body">
              <div className="row">
                {localStorage.getItem("Role") === "1" && (
                  <div className="col-lg-4">
                    <label className="form-label">
                      Select Academy <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                      hidden
                    />
                  </div>
                )}

                <div className="col-lg-4">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => listall(acaid, e.target.value, tdate, urllink)}
                    value={fdate}
                  />
                </div>
                <div className="col-lg-4">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) => listall(acaid, fdate, e.target.value, urllink)}
                    value={tdate}
                  />
                </div>
              </div>
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={
                    urllink === "deletevisitor" ? columnDDefs : columnDefs
                  }
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
